import getUpdatedCandidate from "./getUpdatedCandidate";
import getRegion from "./getRegion";

export default {
    getUpdatedCandidate,
    getRegion
}